import rootSortConfig from './roots-sort.config'
export default [
  ...rootSortConfig,
  // {
  //   title: 'Количество товаров по возрастанию',
  //   field: 'products_count.asc',
  //   options: {
  //     by: 'products_count',
  //     order: 'asc'
  //   }
  // },
  // {
  //   title: 'Количество товаров по убыванию',
  //   field: 'products_count.desc',
  //   options: {
  //     by: 'products_count',
  //     order: 'desc'
  //   }
  // },
]